import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import posed from 'react-pose'

import Spinner from '~/components/loader/Spinner'

const Image = styled.img`
  ${props => (props.position === 'right' ? 'margin-left: 16px;' : null)}
  ${props => (props.position === 'left' ? 'margin-right: 16px;' : null)}
`

const BOX_STYLES = {
  disabled: {
    scale: 1,
    // boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'transparent'
  },
  init: {
    scale: 1,
    // boxShadow: '0 9px 24px 0 rgba(35,41,48,0.15)',
    background: 'transparent'
  },
  hover: {
    scale: 1,
    // boxShadow: '0 24px 24px 0 rgba(35,41,48,0.15)',
    background: 'transparent'
  },
  press: {
    scale: 1,
    // boxShadow: '0 9px 24px 0 rgba(35,41,48,0.05)',
    background: 'transparent'
  }
}

const Box = posed.button({
  hoverable: true,
  pressable: true,
  focusable: true,
  init: {
    ...BOX_STYLES.init
  },
  focus: {
    ...BOX_STYLES.hover,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.hover.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.hover.background
  },
  hover: {
    ...BOX_STYLES.hover,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.hover.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.hover.background
  },
  press: {
    ...BOX_STYLES.press,
    boxShadow: props =>
      props.disabled
        ? BOX_STYLES.disabled.boxShadow
        : BOX_STYLES.press.boxShadow,
    background: props =>
      props.disabled
        ? BOX_STYLES.disabled.background
        : BOX_STYLES.press.background
  },
  disabled: {
    ...BOX_STYLES.disabled
  }
})

const StyledBox = styled(Box)`
  outline: none;
  -webkit-tap-highlight-color: transparent;
  background: #ffffff;
  border: none;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  margin-right: 135px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  color: #000000;
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: 16px;
  user-select: none;
  transition: all 0.5s ease;
  ${props => props.theme.media.smallDesktop`
    margin-right: 15px;
  `}
`
const WhiteButton = ({
  onClick,
  text,
  image,
  position,
  isMobile,
  disabled,
  disabledText = '',
  type,
}) => {
  const imgProps = {
    position,
    src: image
  }
  return (
    <StyledBox
      pose={disabled ? 'disabled' : 'init'}
      isMobile={isMobile}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {disabled ? (
        <>
          {disabledText}
          <Spinner
            isMini
            margin={disabledText ? '0 0 0 1rem' : '0'}
            isMobile={false}
            style={{ display: 'inline-block' }}
          />
        </>
      ) : (
        <>
          {image && position === 'left' ? <Image {...imgProps} /> : null}
          {text}
          {image && position === 'right' ? <Image {...imgProps} /> : null}
          {' '}
        </>
      )}
    </StyledBox>
  )
}

WhiteButton.defaultProps = {
  position: 'right',
  isMobile: false,
  disabled: false,
  disabledText: null,
  image: null,
  type: 'button'
}

WhiteButton.propTypes = {
  isMobile: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  position: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default WhiteButton
